<div class="container-fluid page-body-wrapper">
  <div class="main-panel">
    <div class="content-wrapper">
      <div class="row" *ngIf="permission.dashboard == 1 && home">
        <!-- Financial Cards - Admin Only -->
        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType?.userTypeId == 1">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 class="positive-value">{{home.totalFees | currency : 'GBP'}}</h1>
                  <p class="text-muted mb-0">Total Fees</p>
                </div>
                <i class="icon-wallet text-success icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType?.userTypeId == 1">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1>{{'-' + (home.totalPaid | currency : 'GBP')}}</h1>
                  <p class="text-muted mb-0">Total Paid</p>
                </div>
                <i class="icon-credit-card text-warning icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType?.userTypeId == 1">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 class="negative-value">{{home.totalOutstanding | currency : 'GBP'}}</h1>
                  <p class="text-muted mb-0">Aged Debt</p>
                </div>
                <i class="icon-wallet text-danger icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType?.userTypeId == 1">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 class="positive-value">{{home.totalCommission | currency : 'GBP'}}</h1>
                  <p class="text-muted mb-0">Commission Earned</p>
                </div>
                <i class="icon-diamond text-info icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Case Management Cards - Displayed After Financial Cards -->
        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <a routerLink="/pages/cases/all" class="home-link">
                  <h1>{{home.totalCases}}</h1>
                  </a>
                  <p class="text-muted mb-0">Total Cases</p>
                </div>
                <i class="icon-briefcase text-primary icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 (click)="openModal('upcomingHearings')" class="home-link">{{home.upcomingHearings}}</h1>
                  <p class="text-muted mb-0">Court Hearings</p>
                </div>
                <i class="icon-clock text-primary icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType?.userTypeId == 1">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 (click)="openModal('upcomingDeadline')" class="home-link">{{home.upcomingDeadline}}</h1>
                  <p class="text-muted mb-0">Upcoming Deadlines</p>
                </div>
                <i class="icon-calendar text-primary icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 (click)="openModal('courtListingDue')" class="home-link">{{home.courtListingDue}}</h1>
                  <p class="text-muted mb-0">Court Listings Due</p>
                </div>
                <i class="icon-docs text-primary icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 (click)="openModal('courtBundleDue')" class="home-link">{{home.courtBundleDue}}</h1>
                  <p class="text-muted mb-0">Court Papers Due</p>
                </div>
                <i class="icon-doc text-primary icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 (click)="openModal('attendeceDue')" class="home-link">{{home.attendeceDue}}</h1>
                  <p class="text-muted mb-0">Attendance Notes Due</p>
                </div>
                <i class="icon-note text-primary icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 (click)="openModal('additionalWorkDue')" class="home-link">{{home.additionalWorkDue}}</h1>
                  <p class="text-muted mb-0">Additional Work Due</p>
                </div>
                <i class="icon-layers text-primary icon-lg"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 grid-margin" *ngIf="userType">
          <div class="card card-statistics-single">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h1 (click)="openModal('outstandingDocumentDue')" class="home-link">{{home.outstandingDocumentDue}}</h1>
                  <p class="text-muted mb-0">Outstanding Documents</p>
                </div>
                <i class="icon-folder text-primary icon-lg"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row grid-margin" *ngIf="home">
        <div class="col-md-6 border-right">
          <div class="card">
            <div class="card-body">
                <canvas baseChart
                  [datasets]="barChartData"
                  [labels]="barChartLabels"
                  [options]="barChartOptions"
                  [legend]="barChartLegend"
                  chartType="bar">
                </canvas>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <div style="display: block;">
                <canvas baseChart
                  [data]="pieChartData"
                  [labels]="pieChartLabels"
                  [chartType]="pieChartType"
                  [colors]="colors"
                  [options]="pieChartOptions"
                  [plugins]="pieChartPlugins"
                  [legend]="pieChartLegend">
                </canvas>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="row grid-margin" *ngIf="userType.userTypeId == 1">
        <div class="col-md-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Pending Solicitor Invoices</h4>
              <table class="table table-striped" *ngIf="solicitorInvoices">
                <thead>
                  <tr>
                    <th>Due Date</th>
                    <th>Court Ref</th>
                    <th>Solicitor Name</th>
                    <th>Solicitor Firm</th>
                    <th>Barrister Name</th>
                    <th class="text-right">Total Amount</th>
                    <th class="text-right">Total Paid</th>
                    <th class="text-right">Total Due</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let invoice of solicitorInvoices">
                    <td>{{invoice.dueDate | date : 'dd-MM-yyyy'}}</td>
                    <td>
                      <a routerLink="/pages/cases/view/{{invoice.caseId}}">{{invoice.courtRef}}</a></td>
                    <td>
                      <a routerLink="/pages/solicitors/team/{{invoice.teamId}}">{{invoice.solicitorName}}</a></td>
                    <td>
                      <a routerLink="/pages/solicitors/view/{{invoice.solicitorId}}">{{invoice.companyName}}</a></td>
                    <td>
                      <a routerLink="/pages/barristers/view/{{invoice.barristerId}}">{{invoice.barristerName}}</a></td>
                    <td class="text-right">{{invoice.totalAmount | currency : 'GBP'}}</td>
                    <td class="text-right text-success">{{invoice.totalPaid | currency : 'GBP'}}</td>
                    <td class="text-right text-danger">{{invoice.totalDue | currency : 'GBP'}}</td>
                    <td>
                      <button mat-button [matMenuTriggerFor]="menu" class="btn btn-outline-danger btn-sm">
                        <i class="icon-options"></i>
                      </button>
                      <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="viewInvoice(invoice.id, invoice.caseId)">
                          <i class="icon-eye"></i> View
                        </button>
                        <a href="{{baseUrl}}report/invoice.php?id={{invoice.id}}&tableName=solicitor&caseId={{invoice.caseId}}" target="_blank" mat-menu-item class="no-link">
                          <i class="icon-cloud-download"></i> Download
                        </a>
                      </mat-menu>
                    </td>
                  </tr>
                </tbody>
              </table>
              <app-nodata *ngIf="!solicitorInvoices"></app-nodata>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- content-wrapper ends -->
    <!-- partial -->
  </div>
  <!-- main-panel ends -->
</div>
